import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { theme } from './Theme';

const channelConfig = {
  'Rull.se': (
    <>
      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
      <script type="text/javascript" id="vwoCode">
        {`
        window._vwo_code || (function() {
        var account_id=992973,
        version=2.1,
        settings_tolerance=2000,
        hide_element='body',
        hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
        /* DO NOT EDIT BELOW THIS LINE */
        f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute('nonce',v.nonce);d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement('script'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName('head')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var i=d.createElement('div');i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;';i.setAttribute('id','_vis_opt_path_hides');i.classList.add('_vis_hide_layer');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:s})}else{this.load(s+'&x=true')}}};w._vwo_code=code;code.init();})();
        `}
      </script>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=4f472833-4047-4eb9-ac01-21c3c19cf488"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'General Swedish Support',
                enabled: ['General Swedish Support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/YxDTQY/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="66df4897-fd59-52c1-8ed2-26a044fa3381"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Rull.dk': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=4f472833-4047-4eb9-ac01-21c3c19cf488"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Danish support',
                enabled: ['Danish support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/YxDTQY/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="4122a133-883e-516e-96dc-78bab084aff6"
      ></script>

      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Ruller.no': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=4f472833-4047-4eb9-ac01-21c3c19cf488"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Norwegian support',
                enabled: ['Norwegian support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/YxDTQY/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="3e2beecf-a43c-510b-a6e3-9b7b80586004"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Rull.fi': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=4f472833-4047-4eb9-ac01-21c3c19cf488"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Finnish support',
                enabled: ['Finnish support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/YxDTQY/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="b65b7f0d-dbdb-58b2-90c2-1f005cb68363"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Evobike.se': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=d334bd75-8441-44ff-9b84-387ad3150dbc"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Evobike Support',
                enabled: ['Evobike Support','General Swedish Support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/VUJdrZ/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="e1931960-ddca-5799-993f-6820989fc0df"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init',
          {
            websiteUuid: "a2a22c11-bc5f-4ce7-ac2a-0b4be1e060cd",
          },
        ]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Evobike.dk': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=d334bd75-8441-44ff-9b84-387ad3150dbc"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Danish support',
                enabled: ['Danish support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/VUJdrZ/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="56d02db5-430d-5c16-9834-9072bd857330"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Evobike.no': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=d334bd75-8441-44ff-9b84-387ad3150dbc"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Norwegian support',
                enabled: ['Norwegian support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/VUJdrZ/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="c9ccf316-6ff4-552f-bffb-107b5311ce7d"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Evobike.fi': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=d334bd75-8441-44ff-9b84-387ad3150dbc"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Finnish support',
                enabled: ['Finnish support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/VUJdrZ/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="86629be6-9528-56f3-8a97-c173291a31cd"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Sportig.se': (
    <>
      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
      <script type="text/javascript" id="vwoCode">
        {`
        window._vwo_code || (function() {
        var account_id=992973,
        version=2.1,
        settings_tolerance=2000,
        hide_element='body',
        hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
        /* DO NOT EDIT BELOW THIS LINE */
        f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute('nonce',v.nonce);d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement('script'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName('head')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var i=d.createElement('div');i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;';i.setAttribute('id','_vis_opt_path_hides');i.classList.add('_vis_hide_layer');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:s})}else{this.load(s+'&x=true')}}};w._vwo_code=code;code.init();})();
        `}
      </script>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=28f1bed5-94a6-40cf-99f0-02110ea3b562"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'General Swedish Support',
                enabled: ['General Swedish Support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/QZsB5K/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="129a52b3-981e-5f2e-9b02-a2c84e5539a6"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Sportig.dk': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=28f1bed5-94a6-40cf-99f0-02110ea3b562"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Danish support',
                enabled: ['Danish support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/QZsB5K/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="e4e74ee2-7cc5-51f1-b503-bea33e073712"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Sportig.no': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=28f1bed5-94a6-40cf-99f0-02110ea3b562"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Norwegian support',
                enabled: ['Norwegian support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/QZsB5K/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="37dc42d7-e3ee-5a53-bbc1-a7cd6820928d"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Sportig.fi': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=28f1bed5-94a6-40cf-99f0-02110ea3b562"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Finnish support',
                enabled: ['Finnish support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/QZsB5K/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="ccd68216-fa38-5f6b-b6e3-1e1128cccaa2"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Blimo.se': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=0671955b-d801-426f-8609-863947447f55"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Blimo Support',
                enabled: ['Blimo Support','General Swedish Support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/SNdHxf/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="730200a2-a927-56a0-8b5c-dd05da5d56b5"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Blimo.dk': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=0671955b-d801-426f-8609-863947447f55"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Danish support',
                enabled: ['Danish support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/SNdHxf/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="7e197d06-b931-52c3-8a4c-a60cb05d555e"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Blimo.no': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=0671955b-d801-426f-8609-863947447f55"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Norwegian support',
                enabled: ['Norwegian support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/SNdHxf/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="7da83669-072d-551c-9b90-04da8b7903a5"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Blimo.fi': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=0671955b-d801-426f-8609-863947447f55"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'Finnish support',
                enabled: ['Finnish support']
              }
            }
          }
        };
        `}
      </script>
      <script
        type="text/javascript"
        src="https://static.klaviyo.com/onsite/js/SNdHxf/klaviyo.js"
      />
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="19becf05-2c2c-52d2-a3af-0b22f46c27d4"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Andningslarm.se': (
    <>
      <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
      <script type="text/javascript" id="vwoCode">
        {`
        window._vwo_code || (function() {
        var account_id=992973,
        version=2.1,
        settings_tolerance=2000,
        hide_element='body',
        hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
        /* DO NOT EDIT BELOW THIS LINE */
        f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute('nonce',v.nonce);d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement('script'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName('head')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var i=d.createElement('div');i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;';i.setAttribute('id','_vis_opt_path_hides');i.classList.add('_vis_hide_layer');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:s})}else{this.load(s+'&x=true')}}};w._vwo_code=code;code.init();})();
      `}
      </script>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=9afc9ae3-eed7-44c5-8145-faff89db036e"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'General Swedish Support',
                enabled: ['General Swedish Support']
              }
            }
          }
        };
        `}
      </script>
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="fcb2835b-2c00-5a92-8eac-7b7a20570c7c"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  ),
  'Elmoped.se': (
    <>
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=9afc9ae3-eed7-44c5-8145-faff89db036e"
      ></script>
      <script type="text/javascript">
        {`
        window.zESettings = {
          webWidget: {
            chat: {
              departments: {
                select: 'General Swedish Support',
                enabled: ['General Swedish Support']
              }
            }
          }
        };
        `}
      </script>
      <script
        async
        data-environment="production"
        src="https://js.klarna.com/web-sdk/v1/klarna.js"
        data-client-id="58f71d70-b35d-5124-af10-1c574a9e4440"
      ></script>
      <script async src="https://helloretailcdn.com/helloretail.js"></script>
      <script>
        {`
        hrq = window.hrq || [];
        hrq.push(['init', {}]);
        hrq.push(function(sdk){
            try {
                var cartId = null; //getCookie("JetShop_CartID");
                if (cartId) {
                    fetch("/Services/Rest/v2/json/shoppingcart/" + cartId)
                        .then((response) => response.json())
                        .then((data) => {
                            var productNumbers = [];
                            var cart = data[0];
                            for (i = 0; i < cart.ProductsCart.length; i++) {
                                productNumbers.push(cart.ProductsCart[i].Articlenumber);
                            }
                            sdk.setCart({
                                total: cart.TotalProductSum,
                                url: document.location.protocol + "//" + document.location.hostname + "/externalcheckout.aspx?cartid=" + cart.CartId,
                                productNumbers: productNumbers
                            });
                        });
                }
            } catch(e) {
                console.log(e);
            }
        });
        `}
      </script>
    </>
  )
};

export default function ChannelHelmet() {
  const { selectedChannel } = useContext(ChannelContext);
  const favIcon = theme.favIcon;
  const iconType = theme.favIcon.match(/[^.]*$/);
  return (
    <Helmet>
      {favIcon && iconType && (
        <link
          rel="shortcut icon"
          type={iconType === 'ico' ? 'image/x-icon' : `image/${iconType}`}
          href={favIcon}
        />
      )}
      {channelConfig[selectedChannel.name]}
    </Helmet>
  );
}
